import styled from "styled-components/macro";

export const Root = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex-grow: 1;
  position: relative;
`;

export const DayDelimiterRoot = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
`;

export const DayDelimiterLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${(p) => p.theme.colors.bgSoftGray};
  flex-grow: 1;
`;

export const DayDelimiterText = styled.div`
  white-space: nowrap;
  padding: 0 8px;

  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
export const PreviousMessagesLoaderContainer = styled.div`
  position: sticky;
  left: 0;
  right: 0;
  top: 0;
  height: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
